module.exports = __webpack_public_path__ + "img/icon_mbonus.e145bbef.png";